<div class="cah-edit-details">
    <div class="terms-header">

        <h2> <mat-icon>error_outline</mat-icon> </h2>
        <h2 class="cah-font-20">Please accept the updated Terms & Conditions to continue using {{ displayName }}</h2>
    </div>

    <div class="terms-image"><img src="{{assets}}img/schedule-calendar/warning-rafiki.png" class="img-fluid"></div>

    <div class="row">
        <div class="terms-intro">
            We work constantly to improve our services and develop new features to make our platform better for you and
            our community. As a result, we may need to update these Terms from time to time to accurately reflect our
            services and practices. We will notify you after we make changes to these Terms and give you an opportunity
            to review and accept them.
        </div>
    </div>

    <div class="row mt-3">
        <div class="terms-scrollable-content">
            <div *ngIf="loading" class="text-center py-3">
                <mat-spinner diameter="30" class="mx-auto"></mat-spinner>
                <p class="mt-2">Loading Terms & Conditions...</p>
            </div>
            <div *ngIf="!loading && termsContent" class="terms-content" [innerHTML]="termsContent"></div>
            <div *ngIf="!loading && !termsContent" class="alert alert-warning">
                <p>Terms & Conditions content is not available. Please contact support.</p>
            </div>
        </div>
    </div>


    <div class="row mt-3 note" >
        <mat-checkbox name="Day" color="Primary" class="mt-2 mb-2 mr-2"
        [checked]="accepted" (change)="accepted = !accepted"
        >
        I confirm that I have read, understood and agreed to the updated terms and conditions.
        </mat-checkbox>
      
    </div>

    <div class="row">
        <div class="py-3 mt-3 text-center">
            <button class="btn btn-outline-violet border-rad-17 me-3" (click)="modalClose()">Disagree</button>
            <button class="btn btn-violet border-rad-17" [disabled]="!accepted" (click)="modalClose('yes')"> Yes, I Agree</button>
        </div>
    </div>



</div>